import { init as topPageInit } from "./topPage";
import { init as slideshowInit } from "./common/libs/slideshow";
import { init as movieGalleryInit } from "./common/libs/movieGallery";
import { init as fadeInScrollInit } from "./common/libs/fadeInScroll";
import { init as scrollToInit } from "./common/libs/scrollTo";
import { init as fadeInFromTopPageInit } from "./common/libs/fadeInFromTopPage";
import { init as imageGalleryInit } from "./common/libs/imageGallery";
import { init as projectsGalleryInit } from "./common/libs/projectsGallery";
import { init as projectsDetailGalleryInit } from "./common/libs/projectsDetailGallery";
import { init as formGroupInit } from "./common/libs/formGroup";
import { init as globalNavInit } from "./globalNav";
import { init as mapInit } from "./d04/map";
import { init as anchorLink } from "./common/libs/anchorLink";

const init = () => {
  /** 全ページ共通のスクリプトを実行 */
  scrollToInit();
  globalNavInit();

  /** トップページ用のスクリプトを実行 */
  if (document.querySelector("#page_home")) {
    topPageInit();
    return;
  }

  /** トップページ以外で共通のスクリプトを実行 */
  fadeInFromTopPageInit();
  slideshowInit();
  movieGalleryInit();
  fadeInScrollInit();
  imageGalleryInit();
  projectsGalleryInit();
  projectsDetailGalleryInit();
  formGroupInit();
  mapInit();
  anchorLink();
};

window.addEventListener("DOMContentLoaded", () => {
  init();
});
